import { ClientSelector } from 'components/shared/client-selector';
import { ISalesCounterpart } from 'models/ISalesCounterpart';
import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import './style.scss';

type ClientCardProps = {
  onSkipClientSelection: () => void;
  onClientSelected: (client: ISalesCounterpart) => void;
};

export const ClientCard = ({ onClientSelected, onSkipClientSelection }: ClientCardProps) => {
  const [selectedClient, setSelectedClient] = useState<ISalesCounterpart | null>(null);
  const [areButtonsDisabled, setAreButtonsDisabled] = useState(false);
  const clientSelectorRef = useRef<HTMLDivElement | null>(null);

  const handleClientChanged = (client: ISalesCounterpart | null) => {
    setSelectedClient(client);
    if (client) {
      onClientSelected(client);
      setAreButtonsDisabled(true);
    }
  };

  const handleSkipClientSelection = () => {
    onSkipClientSelection();
    setAreButtonsDisabled(true);
  };

  return (
    <div className="d-flex flex-y client-card">
      <p className="fs-16 mb-3">
        <FormattedMessage id="smartQuote.workspace.main.resultsSummary.selectClientStepLabel" />
      </p>
      <div className="border p-3 flex-y gap-2 content-container">
        <div>
          <FormattedMessage id="smartQuote.workspace.main.clientCard.label" />
        </div>
        <div ref={clientSelectorRef} className="client-selector-container">
          <ClientSelector
            client={selectedClient}
            onClientChanged={handleClientChanged}
            containerRef={clientSelectorRef}
            isDisabled={areButtonsDisabled}
          />
        </div>
        <button
          className="btn btn-lg btn-discreet-secondary"
          onClick={handleSkipClientSelection}
          disabled={areButtonsDisabled}
        >
          <FormattedMessage id="smartQuote.workspace.main.clientCard.notNowButton" />
        </button>
      </div>
    </div>
  );
};
